const formElements = document.querySelectorAll<HTMLFormElement>('.mb-gg');

let checkName = '';
const radioboxesElements = document.querySelectorAll('.mb-gg-simulation-fieldset');
radioboxesElements.forEach(radioboxElement => {
  const labelElements = radioboxElement.querySelectorAll('.mb-gg-simulation-item .mb-gg-radiobox');
  labelElements.forEach(labelElement => {
    const inputElement = labelElement.querySelector('.mb-gg-radiobox-input') as HTMLInputElement;

    inputElement.addEventListener('click', () => {
      checkName = inputElement.name;
      labelElements.forEach(labelElement => {
        const inputElement = labelElement.querySelector('.mb-gg-radiobox-input') as HTMLInputElement;
        if (inputElement.name !== checkName) {
          inputElement.checked = false;
        }
      });
    });
  });
});

formElements.forEach(formElement => {
  const simulationExecuteButton = formElement.querySelector('.simulation-execute-btn') as HTMLButtonElement;
  const simulationReturnButton = formElement.querySelector('.simulation-return-btn') as HTMLButtonElement;
  const simulationBox = formElement.querySelector('.mb-gg-show-box') as HTMLElement;
  const simulationSpBtn = formElement.querySelector('.content-open-btn');
  if (simulationSpBtn) {
    simulationSpBtn.addEventListener('click', () => {
      if (simulationBox.classList.contains('is-active')) {
        simulationBox.classList.remove('is-active');
        simulationSpBtn.classList.remove('is-active');
      } else {
        simulationBox.classList.add('is-active');
        simulationSpBtn.classList.add('is-active');
      }
    });
  } else {
    simulationBox.classList.add('is-active');
  }

  simulationReturnButton.addEventListener('click', () => {
    formElement.classList.remove('is-ok');
    formElement.classList.remove('is-ng');
    simulationBox.classList.add('is-active');
  });

  const simulationElements = formElement.querySelectorAll('.mb-gg-simulation-wrapper');

  simulationElements.forEach((element, index) => {
    const numberElement = element.querySelector('.mb-gg-simulation-number') as HTMLElement;
    numberElement.textContent = (index + 1).toString();
  });

  simulationExecuteButton.addEventListener('click', () => {
    if (simulationSpBtn) {
      simulationSpBtn.classList.remove('is-active');
    }

    let dataFlagCount = 0;
    let results = 0;

    simulationElements.forEach(element => {
      const id = element.getAttribute('data-id') || '';

      if (!id) {
        return;
      }

      const fieldsetElement = element.querySelector('.mb-gg-simulation-fieldset') as HTMLElement;
      const inputType = fieldsetElement.getAttribute('data-type') || '';

      if (inputType === 'radio') {
        const labelElements = fieldsetElement.querySelectorAll<HTMLElement>('.mb-gg-radiobox');
        let clickFlag = false;

        labelElements.forEach(labelElement => {
          labelElement.addEventListener('click', () => {
            clickFlag = true;
            element.classList.remove('has-error');
          });
        });

        const radioNodeList = formElement[`input[${id}]`] as RadioNodeList | undefined;

        if (!radioNodeList || radioNodeList.value === '') {
          element.classList.add('has-error');
          dataFlagCount++;
          return;
        }

        const condition = fieldsetElement.getAttribute('data-condition') || '';
        if (radioNodeList.value === condition) {
          results++;
        }
      } else if (inputType === 'number') {
        const inputElement = element.querySelector('.mb-gg-input') as HTMLInputElement;
        const value = Number(inputElement.value);
        const condition = fieldsetElement.getAttribute('data-condition') || '';
        const segments = condition.split('~').map(segment => segment.trim());
        const ltValue = segments[0]; // 左辺
        const gtValue = segments[1]; // 右辺

        if (!inputElement.value || isNaN(Number(inputElement.value))) {
          element.classList.add('has-error');
          dataFlagCount++;
        } else {
          element.classList.remove('has-error');
        }

        if (!ltValue && gtValue) {
          // ~20
          if (value <= Number(gtValue)) {
            results++;
          }
        } else if (ltValue && !gtValue) {
          // 20~
          if (value >= Number(ltValue)) {
            results++;
          }
        } else if (ltValue && gtValue) {
          // 20~50
          if (value >= Number(ltValue) && value <= Number(gtValue)) {
            results++;
          }
        } else {
          // Error
          element.classList.add('has-error');
        }
      }
    });

    const error = formElement.querySelector('.mb-gg-simulation-error-text') as HTMLElement;

    if (!dataFlagCount) {
      if (results === simulationElements.length) {
        // 全部一致
        formElement.classList.add('is-ok');
        formElement.classList.remove('is-ng');
      } else {
        // 一致してない
        formElement.classList.remove('is-ok');
        formElement.classList.add('is-ng');
      }
      error.classList.remove('is-active');
    } else {
      error.classList.add('is-active');
    }
  });
});
